import { render } from "./save-userdata-popup.vue?vue&type=template&id=9de730e0&scoped=true"
import script from "./save-userdata-popup.vue?vue&type=script&setup=true&lang=js"
export * from "./save-userdata-popup.vue?vue&type=script&setup=true&lang=js"

import "./save-userdata-popup.vue?vue&type=style&index=0&id=9de730e0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9de730e0"],['__file',"src/layouts/main-layout/components/save-userdata-popup/save-userdata-popup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9de730e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9de730e0', __exports__)) {
    api.reload('9de730e0', __exports__)
  }
  
  module.hot.accept("./save-userdata-popup.vue?vue&type=template&id=9de730e0&scoped=true", () => {
    api.rerender('9de730e0', render)
  })

}


export default __exports__